module.exports = __webpack_public_path__ + "static/media/antigua-beaches-23.2cca339e.jpg";